import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaSearch, FaPhone, FaFilter } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../config/config";
import Layout, { Container } from "../components/layout";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Leads = () => {
  const navigate = useNavigate();

  const [leads, setLeads] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [showTagPopup, setShowTagPopup] = useState(false);
  const [showAttemptsPopup, setShowAttemptsPopup] = useState(false);

  const [selectedLeads, setSelectedLeads] = useState([]); // ✅ Selected leads
  const [selectAll, setSelectAll] = useState(false); // ✅ Select all toggle

  const [filters, setFilters] = useState({
    page: 1,
    limit: 100,
    search: "",
    status: "",
    crmStatus: "",
    tags: [], // multiple selected
    crmAttempts: [], // ✅ ADD THIS
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    unique: false, // ✅ NEW
  });

  /* Example Tags (you can fetch dynamically from backend) */
  const availableTags = [
    "Paachan Pro LP",
    "Diacurex LP",
    "KJ LP",
    "Pilescurex LP",
    "Landing Page",
  ];

  // /* ================= FETCH ================= */
  // const fetchLeads = async () => {
  //   try {
  //     setLoading(true);

  //     let params = { ...filters };

  //     /* Convert tags array */
  //     if (filters.tags.length > 0) {
  //       params.tags = filters.tags.join(",");
  //     } else {
  //       delete params.tags;
  //     }

  //     /* Combine Date + Time */
  //     if (filters.startDate) {
  //       const start = new Date(
  //         `${filters.startDate}T${filters.startTime || "00:00"}`,
  //       );
  //       params.startDate = start.toISOString();
  //     }

  //     if (filters.endDate) {
  //       const end = new Date(
  //         `${filters.endDate}T${filters.endTime || "23:59"}`,
  //       );
  //       params.endDate = end.toISOString();
  //     }

  //     delete params.startTime;
  //     delete params.endTime;

  //     /* Remove empty */
  //     Object.keys(params).forEach((key) => {
  //       if (params[key] === "" || params[key] === undefined) {
  //         delete params[key];
  //       }
  //     });

  //     console.log("FINAL PARAMS", params); // 🔥 DEBUG

  //     const { data } = await axios.get(`${apiurl}/api/lead/get`, {
  //       params,
  //     });

  //     setLeads(data.leads);
  //     setPagination(data.pagination);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchLeads = async () => {
    try {
      setLoading(true);

      let params = { ...filters };

      /* Convert tags array */
      if (filters.tags.length > 0) {
        params.tags = filters.tags.join(",");
      } else {
        delete params.tags;
      }

      /* ✅ Convert CRM Attempts array */
      if (filters.crmAttempts.length > 0) {
        params.crmAttempts = filters.crmAttempts.join(",");
      } else {
        delete params.crmAttempts;
      }

      if (filters.unique) {
        params.unique = true;
      } else {
        delete params.unique;
      }

      /* Combine Date + Time */
      if (filters.startDate) {
        const start = new Date(
          `${filters.startDate}T${filters.startTime || "00:00"}`,
        );
        params.startDate = start.toISOString();
      }

      if (filters.endDate) {
        const end = new Date(
          `${filters.endDate}T${filters.endTime || "23:59"}`,
        );
        params.endDate = end.toISOString();
      }

      delete params.startTime;
      delete params.endTime;

      /* Remove empty values */
      Object.keys(params).forEach((key) => {
        if (
          params[key] === "" ||
          params[key] === undefined ||
          (Array.isArray(params[key]) && params[key].length === 0)
        ) {
          delete params[key];
        }
      });

      console.log("FINAL PARAMS", params); // 🔥 DEBUG

      const { data } = await axios.get(`${apiurl}/api/lead/get`, {
        params,
      });

      setLeads(data.leads);
      setPagination(data.pagination);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLeads();
  }, [filters]);

  /* ================= HANDLERS ================= */

  const handleSearch = (e) => {
    setFilters({ ...filters, search: e.target.value, page: 1 });
  };

  const handleTagChange = (tag) => {
    let updatedTags = [...filters.tags];

    if (updatedTags.includes(tag)) {
      updatedTags = updatedTags.filter((t) => t !== tag);
    } else {
      updatedTags.push(tag);
    }

    setFilters({ ...filters, tags: updatedTags, page: 1 });
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > pagination.totalPages) return;
    setFilters({ ...filters, page });
  };

  const handlePerPageChange = (e) => {
    setFilters({
      ...filters,
      limit: Number(e.target.value),
      page: 1,
    });
  };

  const clearFilters = () => {
    setFilters({
      page: 1,
      limit: 100,
      search: "",
      status: "",
      crmStatus: "",
      tags: [],
      crmAttempts: [], 
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
    });
  };

  const navigateToLead = (id) => {
    const url = `/sales/leads/${id}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // ✅ Handle select single lead
  const toggleLeadSelection = (id) => {
    let updated = [...selectedLeads];
    if (updated.includes(id)) updated = updated.filter((i) => i !== id);
    else updated.push(id);
    setSelectedLeads(updated);

    if (updated.length === leads.length) setSelectAll(true);
    else setSelectAll(false);
  };

  // ✅ Handle select all leads on current page
  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedLeads([]);
      setSelectAll(false);
    } else {
      const allIds = leads.map((l) => l._id);
      setSelectedLeads(allIds);
      setSelectAll(true);
    }
  };

  const exportSelectedToExcel = () => {
    if (selectedLeads.length === 0) return;

    const excelData = leads
      .filter((l) => selectedLeads.includes(l._id))
      .map((lead) => ({
        Name: lead.fullName,
        Phone: lead.phone,
        CRM: lead.integrations?.find((i) => i.name === "crm")?.status || "",
        Facebook:
          lead.integrations?.find((i) => i.name === "facebook")?.status || "",
        CRM_Attempts:
          lead.integrations?.find((i) => i.name === "crm")?.attempts || 0,
        Status: lead.status,
        Tags: lead.landingPage || "",
        Created: new Date(lead.createdAt).toLocaleString(),
      }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Leads");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    saveAs(
      new Blob([excelBuffer], { type: "application/octet-stream" }),
      `Selected_Leads_${new Date().toISOString()}.xlsx`,
    );
  };

  const exportToExcel = async () => {
    try {
      let params = { ...filters };
      if (filters.tags.length) params.tags = filters.tags.join(",");
      if (filters.crmAttempts.length)
        params.crmAttempts = filters.crmAttempts.join(",");
      if (filters.unique) params.unique = true;

      // API call to get all leads without pagination
      params.page = 1;
      params.limit = 5000; // max limit for export

      const { data } = await axios.get(`${apiurl}/api/lead/get`, { params });

      if (!data.leads || data.leads.length === 0) return;

      // Map leads to simple object for Excel
      const excelData = data.leads.map((lead) => ({
        Name: lead.fullName,
        Phone: lead.phone,
        CRM: lead.integrations?.find((i) => i.name === "crm")?.status || "",
        Facebook:
          lead.integrations?.find((i) => i.name === "facebook")?.status || "",
        CRM_Attempts:
          lead.integrations?.find((i) => i.name === "crm")?.attempts || 0,
        Status: lead.status,
        Tags: lead.landingPage || "",
        Created: new Date(lead.createdAt).toLocaleString(),
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(file, `Leads_${new Date().toISOString()}.xlsx`);
    } catch (err) {
      console.error("Export error", err);
    }
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-2 bg-gray-100 min-h-screen">
          {/* HEADER */}
          <div className="flex justify-between mb-6">
            <div>
              <h1 className="text-2xl font-semibold">Leads</h1>
              <p className="text-sm text-gray-500">
                Manage and monitor all incoming leads
              </p>
            </div>
            <div className="text-sm text-gray-600">
              Total: {pagination.totalLeads || 0}
            </div>
          </div>

          <div className="bg-white p-4 rounded-xl shadow mb-6 flex flex-wrap gap-2 items-center">
            {/* Search */}
            <div className="flex items-center border rounded-lg px-3 py-2 w-64">
              <FaSearch className="text-gray-400" />
              <input
                type="text"
                placeholder="Search..."
                value={filters.search}
                onChange={handleSearch}
                className="ml-2 outline-none w-full text-sm"
              />
            </div>

            {/* Lead Status */}
            <select
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value, page: 1 })
              }
              className="border rounded-lg px-3 py-2 text-sm"
            >
              <option value="">All Lead Status</option>
              <option value="pending">Pending</option>
              <option value="success">Success</option>
              <option value="closed">Closed</option>
            </select>

            {/* CRM Status */}
            <select
              value={filters.crmStatus}
              onChange={(e) =>
                setFilters({ ...filters, crmStatus: e.target.value, page: 1 })
              }
              className="border rounded-lg px-3 py-2 text-sm"
            >
              <option value="">All CRM Status</option>
              <option value="success">Success</option>
              <option value="failed">Failed</option>
              <option value="pending">Pending</option>
            </select>

            {/* Date + Time */}
            <div className="flex gap-2 items-center">
              <input
                type="date"
                value={filters.startDate}
                onChange={(e) =>
                  setFilters({ ...filters, startDate: e.target.value, page: 1 })
                }
                className="border rounded-lg px-2 py-2 text-sm"
              />
              <input
                type="time"
                value={filters.startTime}
                onChange={(e) =>
                  setFilters({ ...filters, startTime: e.target.value, page: 1 })
                }
                className="border rounded-lg px-2 py-2 text-sm"
              />
            </div>
            <div className="flex gap-2 items-center">
              <input
                type="date"
                value={filters.endDate}
                onChange={(e) =>
                  setFilters({ ...filters, endDate: e.target.value, page: 1 })
                }
                className="border rounded-lg px-2 py-2 text-sm"
              />
              <input
                type="time"
                value={filters.endTime}
                onChange={(e) =>
                  setFilters({ ...filters, endTime: e.target.value, page: 1 })
                }
                className="border rounded-lg px-2 py-2 text-sm"
              />
            </div>

            {/* Tags Popup */}
            <div className="relative">
              <button
                onClick={() => setShowTagPopup(!showTagPopup)}
                className={`flex items-center gap-2 ${filters.tags.length > 0 ? "bg-blue-500 text-white" : "bg-white text-gray-700 border"} px-4 py-2 rounded-lg text-sm`}
              >
                <FaFilter /> Tags ({filters.tags.length})
              </button>
              {showTagPopup && (
                <div className="absolute z-50 top-12 left-0 bg-white shadow-xl rounded-xl p-4 w-64 border">
                  <div className="font-semibold mb-3">Select Tags</div>
                  {availableTags.map((tag) => (
                    <div key={tag} className="flex items-center gap-2 mb-2">
                      <input
                        type="checkbox"
                        checked={filters.tags.includes(tag)}
                        onChange={() => handleTagChange(tag)}
                      />
                      <label>{tag}</label>
                    </div>
                  ))}
                  <div className="flex justify-end mt-3">
                    <button
                      onClick={() => setShowTagPopup(false)}
                      className="text-sm text-blue-600"
                    >
                      Done
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* CRM Attempts Popup */}
            <div className="relative">
              <button
                onClick={() => setShowAttemptsPopup(!showAttemptsPopup)}
                className={`flex items-center gap-2 ${filters.crmAttempts.length > 0 ? "bg-green-500 text-white" : "bg-white text-gray-700 border"} px-4 py-2 rounded-lg text-sm`}
              >
                CRM Attempts ({filters.crmAttempts.length})
              </button>
              {showAttemptsPopup && (
                <div className="absolute z-50 top-12 left-0 bg-white shadow-xl rounded-xl p-4 w-56 border">
                  <div className="font-semibold mb-3">Select Attempts</div>
                  {[0, 1, 2, 3, 4, 5].map((num) => (
                    <div key={num} className="flex items-center gap-2 mb-2">
                      <input
                        type="checkbox"
                        checked={filters.crmAttempts.includes(num)}
                        onChange={() => {
                          let updated;
                          if (filters.crmAttempts.includes(num))
                            updated = filters.crmAttempts.filter(
                              (n) => n !== num,
                            );
                          else updated = [...filters.crmAttempts, num];
                          setFilters({
                            ...filters,
                            crmAttempts: updated,
                            page: 1,
                          });
                        }}
                      />
                      <label>{num}</label>
                    </div>
                  ))}
                  <div className="flex justify-end mt-3">
                    <button
                      onClick={() => setShowAttemptsPopup(false)}
                      className="text-sm text-green-600"
                    >
                      Done
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Unique Switch */}
            <div className="flex items-center gap-3">
              <label className="text-sm font-medium select-none">
                Unique by Phone
              </label>
              <button
                onClick={() =>
                  setFilters({ ...filters, unique: !filters.unique, page: 1 })
                }
                className={`relative inline-flex items-center h-7 w-14 rounded-full transition-colors duration-300 focus:outline-none ${filters.unique ? "bg-blue-500" : "bg-gray-300"}`}
              >
                {/* Toggle Circle */}
                <span
                  className={`inline-block w-6 h-6 bg-white rounded-full shadow transform transition-transform duration-300 ${filters.unique ? "translate-x-7" : "translate-x-1"}`}
                ></span>
                {/* Optional ON/OFF Text */}
                <span
                  className={`absolute text-xs font-semibold text-white left-2.5 ${filters.unique ? "opacity-100" : "opacity-0"} transition-opacity duration-300`}
                >
                  ON
                </span>
                <span
                  className={`absolute text-xs font-semibold text-gray-700 right-2.5 ${filters.unique ? "opacity-0" : "opacity-100"} transition-opacity duration-300`}
                >
                  OFF
                </span>
              </button>
            </div>

            <button
              onClick={clearFilters}
              className="bg-red-100 px-4 py-2 rounded-lg text-sm text-red-500 border border-red-300"
            >
              Clear
            </button>

            <select
              value={filters.limit}
              onChange={handlePerPageChange}
              className="border rounded-lg px-3 py-2 text-sm"
            >
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={2500}>2500</option>
              <option value={5000}>5000</option>
              <option value={10000}>10000</option>
            </select>

            <div className="flex justify-between items-center p-4 gap-2">
              <button
                disabled={filters.page <= 1}
                onClick={() => handlePageChange(filters.page - 1)}
                className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
              >
                Previous
              </button>
              <div className="mx-3">
                Page {filters.page} of {pagination.totalPages || 1}
              </div>
              <button
                disabled={filters.page >= pagination.totalPages}
                onClick={() => handlePageChange(filters.page + 1)}
                className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
              >
                Next
              </button>

              <button
                onClick={exportSelectedToExcel}
                disabled={selectedLeads.length === 0}
                className="bg-green-500 text-white px-4 py-2 rounded-lg text-sm disabled:opacity-50"
              >
                Download Selected ({selectedLeads.length})
              </button>

              <button
                onClick={exportToExcel}
                className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm"
              >
                Export All
              </button>
            </div>
          </div>

          {/* TABLE */}
          <div className="bg-white rounded-xl shadow overflow-hidden">
            {loading ? (
              <div className="p-8 text-center text-gray-500">
                Loading leads...
              </div>
            ) : (
              <table className="w-full text-left text-sm">
                <thead className="bg-gray-50 border-b">
                  <tr>
                    <th className="p-4">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th className="p-4">Name</th>
                    <th className="p-4">Phone</th>
                    <th className="p-4">CRM</th>
                    <th className="p-4">Facebook</th>
                    <th className="p-4">CRM Attempts</th>
                    <th className="p-4">Status</th>
                    <th className="p-4">Tags</th>
                    <th className="p-4">Created</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((lead) => {
                    const crm = lead.integrations?.find(
                      (i) => i.name === "crm",
                    );
                    const fb = lead.integrations?.find(
                      (i) => i.name === "facebook",
                    );
                    return (
                      <tr
                        key={lead._id}
                        className="border-b hover:bg-gray-50 cursor-pointer"
                      >
                        <td className="p-4">
                          <input
                            type="checkbox"
                            checked={selectedLeads.includes(lead._id)}
                            onChange={(e) => {
                              e.stopPropagation();
                              toggleLeadSelection(lead._id);
                            }}
                          />
                        </td>
                        <td
                          className="p-4 max-w-64 truncate"
                          onClick={() => navigateToLead(lead._id)}
                        >
                          {lead.fullName}
                        </td>
                        <td className="p-4 flex items-center gap-2">
                          <FaPhone /> {lead.phone}
                        </td>
                        <td className="p-4">
                          <StatusBadge status={crm?.status} />
                        </td>
                        <td className="p-4">
                          <StatusBadge status={fb?.status} />
                        </td>
                        <td className="p-4">{crm?.attempts || 0}</td>
                        <td className="p-4">
                          <StatusBadge status={lead.status} />
                        </td>
                        <td className="p-4">
                          <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-2">
                            {lead.landingPage || "—"}
                          </span>
                        </td>
                        <td className="p-4">
                          {new Date(lead.createdAt).toLocaleString()}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

const StatusBadge = ({ status }) => {
  const base = "px-3 py-1 rounded-full text-xs font-medium";

  if (!status)
    return (
      <span className={`${base} bg-yellow-100 text-yellow-700`}>Pending</span>
    );

  if (status === "success")
    return (
      <span className={`${base} bg-green-100 text-green-700`}>Success</span>
    );

  if (status === "failed")
    return <span className={`${base} bg-red-100 text-red-700`}>Failed</span>;

  return <span className={`${base} bg-gray-100 text-gray-700`}>{status}</span>;
};

export default Leads;
